import { PerformanceTracking } from '@shared/tracking';
import { Action } from './actions';
import { Reducer } from './store';

const STORAGE_KEY = 'datastore_session_store_v3';

export function sessionStorageSyncFactory(
  performanceTracking: PerformanceTracking,
) {
  return (reducer: Reducer<any>) => {
    let firstState = true;
    let pendingWrite = false;
    return (state: any, action: Action) => {
      let nextState = state;
      if (firstState) {
        try {
          performanceTracking.mark('read-session-storage-start');
          const sessionStorageState = JSON.parse(
            window.sessionStorage.getItem(STORAGE_KEY) || '{}',
          );
          performanceTracking.mark('read-session-storage-end');
          performanceTracking.measure(
            'read-session-storage',
            'read-session-storage-start',
            'read-session-storage-end',
          );
          nextState = {
            ...state,
            ...sessionStorageState,
          };
        } catch (e) {
          // ignore the errors, e.g. quota is full or security error
          console.error(e);
        }
      }
      firstState = false;
      const next = reducer(nextState, action);
      if (!pendingWrite) {
        pendingWrite = true;
        (<any>window).requestIdleCallback(() => {
          try {
            performanceTracking.mark('write-session-storage-start');
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            performanceTracking.mark('write-session-storage-end');
            performanceTracking.measure(
              'write-session-storage',
              'write-session-storage-start',
              'write-session-storage-end',
            );
          } catch (e) {
            // ignore the errors, e.g. quota is full or security error
            console.error(e);
          }
          pendingWrite = false;
        });
      }

      return next;
    };
  };
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/session-storage-sync.reducer.ts